import type { Component } from 'react';
import { findDOMNode } from 'react-dom';

export function getDOMNode(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- matches the Flow original's own untyped Component<any, any>
  componentOrElement: Element | Component<any, any> | null
): Element | Text {
  const node = findDOMNode(componentOrElement);
  if (node === null) {
    throw new Error(
      `Could not find DOM node by selector '${JSON.stringify(
        componentOrElement
      )}'`
    );
  }
  return node;
}

export function withDocumentBody<V>(f: (body: HTMLElement) => V): V {
  if (document.body) {
    return f(document.body);
  }
  throw new Error('document.body not present');
}

export function withDocumentHead<V>(f: (head: HTMLElement) => V): V {
  if (document.head) {
    return f(document.head);
  }
  throw new Error('document.head not present');
}

export function withElement<V, Other>(
  maybeElement: Element | Other,
  whenElement: (element: Element) => V,
  whenNotElement?: (other: Other) => V
): V | null {
  if (maybeElement instanceof Element) {
    return whenElement(maybeElement);
  } else if (whenNotElement) {
    return whenNotElement(maybeElement);
  } else {
    const received =
      JSON.stringify(maybeElement) ||
      'something for which JSON.stringify fails';
    throw new Error(
      `Expected an instance of Element, instead received ${received}`
    );
  }
}
